import { memo, useState, useSyncExternalStore } from 'react';

import AudioOverlay from '@/Pages/Clip/ClipPlayer/ClipAssets/AudioOverlay/AudioOverlay';
import AudioOverlayLibraryModal from '@/Pages/Clip/ClipPlayer/ClipAssets/AudioOverlay/AudioOverlayLibraryModal';
import { useAudioOverlay } from '@/Pages/Clip/ClipPlayer/ClipAssets/AudioOverlay/useAudioOverlay';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

const ClipCustomizerAudioPopup = ({ closePopup }: { closePopup: () => void }) => {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isUseCLReplaceAudioEnabled = featureFlags[FeatureFlagKeys.Use_CL_Replace_Audio];

  const [isLibraryModalOpen, setIsLibraryModalOpen] = useState(Boolean(isUseCLReplaceAudioEnabled));
  const { uploadAudio, selectLibraryMusic } = useAudioOverlay();

  const handleModalConfirm = async (
    selection: { type: 'library'; musicId: string } | { type: 'upload'; file: File }
  ) => {
    if (selection.type === 'library') {
      await selectLibraryMusic(selection.musicId);
    } else {
      await uploadAudio([selection.file]);
    }

    setIsLibraryModalOpen(false);
    closePopup();
  };

  if (isUseCLReplaceAudioEnabled) {
    return (
      <AudioOverlayLibraryModal
        isOpen={isLibraryModalOpen}
        onClose={() => {
          setIsLibraryModalOpen(false);
          closePopup();
        }}
        onConfirm={handleModalConfirm}
      />
    );
  }

  return (
    <div className="flex max-h-[54vh] w-[23rem] flex-col overflow-y-auto rounded-lg border bg-white shadow">
      <div className="sticky top-0 z-10 mb-4 flex items-center justify-between bg-white px-4 pt-3">
        <div className="text-lg font-medium">Audio</div>
      </div>
      <div className="mb-4 px-4">
        <AudioOverlay onUploadComplete={closePopup} />
      </div>
    </div>
  );
};

export default memo(ClipCustomizerAudioPopup);
